export const SUCCESS_DEFAULT = 'SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'FAILURE_DEFAULT';
export const HTTP_CLIENT = 'AXIOS';
export const DESTROY_SESSION = 'DESTROY_SESSION';
